export default class CTA {
	constructor(block) {
		this.block = block;
		this.config = {
			childList: true,
			subtree: true,
		};

		if (!this.block) {
			return;
		}

		this.wrapper = this.block.querySelector(".form-wrapper");

		window.addEventListener("DOMContentLoaded", () => {
			this.wrapper.querySelector("style").remove();
			this.wrapper.classList.add("is-visible");
		});
	}
}
